import { useState, useEffect, useRef } from "react";
import { useTranslation } from "react-i18next";
import { Alert } from "antd";
import { LoadingOutlined } from "@ant-design/icons";

const HINT_START_DELAY = 1500;
const HINT_ROTATE_INTERVAL = 4000;

const CheckingPayment = () => {
  const { t } = useTranslation();
  const [hint, setHint] = useState(null);
  const startTimeoutRef = useRef(null);
  const intervalRef = useRef(null);

  useEffect(() => {
    const hints = t("paypal.checkingPaymentHints", { returnObjects: true });
    if (!Array.isArray(hints) || hints.length === 0) return undefined;

    const pickRandom = () => hints[Math.floor(Math.random() * hints.length)];

    startTimeoutRef.current = setTimeout(() => {
      setHint(pickRandom());
      intervalRef.current = setInterval(() => setHint(pickRandom()), HINT_ROTATE_INTERVAL);
    }, HINT_START_DELAY);

    return () => {
      clearTimeout(startTimeoutRef.current);
      clearInterval(intervalRef.current);
    };
  }, [t]);

  return (
    <div className="payment-loading">
      <Alert
        message={
          <div className="payment-loading-alert">
            <LoadingOutlined /> {t("paypal.checkingPayment")}
          </div>
        }
        description={hint || undefined}
        type="warning"
      />
    </div>
  );
};

export default CheckingPayment;
